import { render, staticRenderFns } from "./HumusClasses.vue?vue&type=template&id=22868c55&scoped=true&"
import script from "./HumusClasses.vue?vue&type=script&lang=js&"
export * from "./HumusClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22868c55",
  null
  
)

export default component.exports